import { isAxiosError } from 'axios';

function firstFieldError(data: Record<string, unknown>): string | undefined {
  for (const value of Object.values(data)) {
    if (typeof value === 'string') return value;
    if (Array.isArray(value) && value.length > 0 && typeof value[0] === 'string') {
      return value[0];
    }
  }
  return undefined;
}

/** Normalize Axios / thrown errors into a message. Prefers RCM `{error}` then DRF `{detail}`. */
export function extractApiErrorMessage(error: unknown): string {
  if (isAxiosError(error)) {
    const data = error.response?.data as Record<string, unknown> | string | undefined;

    if (typeof data === 'string' && data.trim()) return data;

    if (data && typeof data === 'object') {
      const err = typeof data.error === 'string' ? data.error : undefined;
      const detail = typeof data.detail === 'string' ? data.detail : undefined;
      const message = typeof data.message === 'string' ? data.message : undefined;

      if (err) return err;
      if (detail) return detail;
      if (message) return message;

      const field = firstFieldError(data);
      if (field) return field;
    }

    return error.message || 'Request failed';
  }

  if (error instanceof Error) return error.message;
  return 'Something went wrong';
}

export function errorStatus(error: unknown): number | null {
  if (isAxiosError(error)) return error.response?.status ?? null;
  return null;
}

export function isClientError(error: unknown): boolean {
  const status = errorStatus(error);
  return status != null && status >= 400 && status < 500;
}
